import { render, staticRenderFns } from "./formularioTratamientos.vue?vue&type=template&id=5f330679&scoped=true"
import script from "./formularioTratamientos.vue?vue&type=script&lang=js"
export * from "./formularioTratamientos.vue?vue&type=script&lang=js"
import style0 from "./formularioTratamientos.vue?vue&type=style&index=0&id=5f330679&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f330679",
  null
  
)

export default component.exports